import { Tokens } from "@pandacss/dev";

export const tokens: Tokens = {
  zIndex: {
    tooltip: {
      value: 1070,
    },
  },
};
